module.exports = __webpack_public_path__ + "static/media/goat.2fcf0723.svg";